import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeTypeModel } from '../model/employee-type.model';
import { EmployeeTypeService } from '../employee-type.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-employee-type-edit',
  templateUrl: './employee-type-edit.component.html',
  styleUrls: ['./employee-type-edit.component.scss'],
  standalone: false
})
export class EmployeeTypeEditComponent implements DirtyCheck {
  title: string = "Employee Type Details";
  editForm: FormGroup;
  employeeTypeInfo: EmployeeTypeModel = {};
  isFormDirty: boolean = false;
  permission: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private employeeTypeService: EmployeeTypeService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService
  ) {
    let id = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: [{ value: '', disabled: true }],
      name: [{ value: '', disabled: true }],
      description: [{ value: '', disabled: true }],
      fg_color: ['#000000'],
      bg_color: ['#ffffff'],
      is_active: [{ value: 1, disabled: true }]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (id !== null && parseInt(id) !== 0) {
      this.setEmployeeTypeInfo(id);
    }
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission("employee-type"), id);
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/system/employee-type']);
  }

  setEmployeeTypeInfo(id: any): void {
    this.employeeTypeService.getEmployeeTypeById(id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.employeeTypeInfo = response.data.employee_type;
          this.editForm.patchValue(this.employeeTypeInfo);
          this.title = "Editing : " + this.employeeTypeInfo.name;
          this.isFormDirty = false;
        } else {
          this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
        }
      }
    });
  }

  save(): void {
    if (this.editForm.valid) {
      // Get only enabled fields or manually pick color fields
      const updatedData = {
        id: this.employeeTypeInfo.id,
        fg_color: this.editForm.get('fg_color')?.value,
        bg_color: this.editForm.get('bg_color')?.value
      };

      this.employeeTypeService.update(updatedData).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            this.snackBarService.openSnackBar({
              type: 'success',
              title: 'Saved',
              message: `Record for ${this.employeeTypeInfo.name} has been updated successfully.`
            });
            this.router.navigate(['/system/employee-type']);
          } else {
            this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
          }
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
